// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import O1HD from "../../../../../engines/gameEngine";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettleLawsuitSpecialHeadNode extends BaseComponent {

    @property(cc.Label)
    labelName: cc.Label = null;

    @property(cc.Sprite)
    sprHead: cc.Sprite = null;
    
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {

        this.initUI();
    }

    initUI() {
        let id = this._carryData.id;
        let info = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.LEGAL_CASE_PEOPLE, id);
        if (!info) {
            console.error(`未找到头像数据`);
            return;
        }

        this.labelName.string = info.name;

        this.sprHead.node.active = false;
        let meHead = "res/common/person/small/" + info.icon_min;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.settleLawsuitBundle).load(meHead, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.sprHead.node.active = true;
                    this.sprHead.spriteFrame = imgs;
                }
            }
        );
    }

    onClick() {
        // O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this._carryData.parent.onClickSelect(this._carryData.idx);
    }

    // update (dt) {}
}
